import { Link2 } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Provenance tag — visually anchors any answer/insight back to its source.
 * Variants:
 *  - amber (default): reflection / M&M / operative-note / surgeon memory
 *  - blue: literature / library / imaging
 *
 * When `active` is true the chip renders in its "preview is open"
 * highlighted state — the visual link between the chip and the
 * floating Quick Preview that sprang from it.
 */
export default function ProvenanceTag({
  kind = "amber",
  label,
  ref,
  onClick,
  active = false,
  justOpened = false,
  className,
  testId,
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      data-active={active || undefined}
      data-just-opened={justOpened || undefined}
      onClick={onClick}
      className={cn("nn-prov", kind === "blue" && "nn-prov-blue", className)}
    >
      <Link2 className="h-2.5 w-2.5" strokeWidth={2} />
      <span className="uppercase tracking-[0.06em]">{label}</span>
      {ref && (
        <span className="text-[hsl(var(--nn-ink-faint))]">·</span>
      )}
      {ref && <span>{ref}</span>}
    </button>
  );
}
